module.exports = __webpack_public_path__ + "img/1598.9434ef72.png";